import React from 'react';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class Campeonato2025 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 182; i <= 207; i++) {
        	id_list.push(i);
        }
    this.state = {
	showCards: true,
      path: this.props.path,
	kits:[],
        kit_path: '/images_fem/kits/todas/',
      ctype: this.props.ctype,
      torneo: this.props.torneo,
      id_list: id_list,

table2:[{'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':26, 'pg':4,'pe':6,'pp':16,'gf':24,'gc':55,'dif':-31, 'pts':18},
              {'color':'#295e1e','shortname':'iquique', 'rivalName':'Dep. Iquique', 'pj':26, 'pg':13,'pe':6,'pp':7,'gf':42,'gc':26,'dif':16, 'pts':45},
              {'color':'#295e1e','shortname':'coquimbo', 'rivalName':'Coquimbo U.', 'pj':26, 'pg':15,'pe':5,'pp':6,'gf':57,'gc':29,'dif':28, 'pts':50},
              {'color':'#E42727','shortname':'everton', 'rivalName':'Everton', 'pj':26, 'pg':3,'pe':5,'pp':18,'gf':19,'gc':69,'dif':-50, 'pts':14},
              {'color':0,'shortname':'recoleta', 'rivalName':'Dep. Recoleta', 'pj':26, 'pg':4,'pe':3,'pp':19,'gf':14,'gc':81,'dif':-67, 'pts':15},
              {'color':0,'shortname':'wanderers', 'rivalName':'S. Wanderers', 'pj':26, 'pg':9,'pe':7,'pp':10,'gf':40,'gc':45,'dif':-5, 'pts':28},
              {'color':'#295e1e','shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':26, 'pg':26,'pe':0,'pp':0,'gf':133,'gc':5,'dif':128, 'pts':75},
              {'color':'#295e1e','shortname':'udechile', 'rivalName':'U. de Chile', 'pj':26, 'pg':21,'pe':2,'pp':3,'gf':75,'gc':21,'dif':54, 'pts':65},
                {'color':'#295e1e','shortname':'palestino', 'rivalName':'Palestino', 'pj':26, 'pg':9,'pe':5,'pp':12,'gf':40,'gc':43,'dif':-3, 'pts':32},
                {'color':'#E42727','shortname':'audax', 'rivalName':'A. Italiano', 'pj':26, 'pg':0,'pe':3,'pp':23,'gf':19,'gc':106,'dif':-87, 'pts':3},
                {'color':'#295e1e','shortname':'catolica', 'rivalName':'U. Católica', 'pj':26, 'pg':13,'pe':3,'pp':10,'gf':60,'gc':25,'dif':35, 'pts':45},
                {'color':'#295e1e','shortname':'huachipato', 'rivalName':'Huachipato', 'pj':26, 'pg':11,'pe':3,'pp':12,'gf':34,'gc':49,'dif':-15, 'pts':36},
                {'color':0,'shortname':'morning', 'rivalName':'S. Morning', 'pj':26, 'pg':9,'pe':4,'pp':13,'gf':29,'gc':52,'dif':-23, 'pts':28},
              {'color':'#295e1e','shortname':'union', 'rivalName':'U. Española', 'pj':26, 'pg':15,'pe':6,'pp':5,'gf':41,'gc':21,'dif':20, 'pts':51}]





    };
  }

  componentDidMount() {
		this.getKits();
		let newtable = this.sortTable(this.state.table2);
  		this.setState({table2:newtable});
	}
 getKits(){

        fetch("https://www.registrosudec.com:5000/kits_femenino", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", socks:"blue", count:15, 
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}




  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={2} xl={2} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}


sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
			aux = table[j+1];
			table[j+1] = table[j];
                        table[j] = aux;
		} 
	     }		
	}
return table;

}


render(){


  let subT = this.subText('#295e1e', 'Clasificado a Play-Off');
  let subC = this.subText('#E42727', 'Desciende a Primera B');
  return(

	<div style={{textAlign: 'center' }}>
	      <div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Campeonato 2025</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>

      <div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Tabla General </div>
	<div style={{ height: '10px' }}></div>
	{<Tabla teams={this.state.table2} />}
	<div style={{ height: '10px' }}></div>
        <div> * S. Morning tiene 3 puntos menos por sanción en torneo pasado</div>
	<div> * S. Wanderers tiene 6 puntos menos por sanción en torneo pasado</div>
        <div style={{ height: '10px' }}></div>
         {subT}
	{subC}


	
	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Campeonato 2025</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Campeonato 2025</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Campeonato 2025" />
     </div>


  )
}

}
export default Campeonato2025;
